<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
      class="mt-12"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-card-text>
            <v-alert type="error" v-if="errorMessage">
              {{ errorMessage }}
            </v-alert>
            <v-text-field
              label="Email"
              v-model="email"
              prepend-icon="mdi-account"
            ></v-text-field>
            <v-text-field
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="login({ email, password})"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block :loading="loadingUser" @click="login({ email, password})">Sign in</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    email: '',
    password: '',
    showPassword: false
  }),
  methods: {
    ...mapActions(['login'])
  },
  computed: {
    ...mapState(['errorMessage', 'loadingUser'])
  }
}
</script>
